import axios from 'axios';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动添加用户ID到请求头
api.interceptors.request.use(
  (config) => {
    // 优先从localStorage获取正式用户信息
    let currentUserStr = localStorage.getItem('currentUser');
    let isGuest = false;
    
    // 如果没有正式用户，尝试获取游客用户
    if (!currentUserStr) {
      currentUserStr = localStorage.getItem('guestUser');
      isGuest = true;
    }
    
    if (currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);
        // 添加用户ID到请求头用于权限验证
        if (currentUser.id) {
          config.headers['X-User-ID'] = currentUser.id;
        }
      } catch (e) {
        console.error('解析用户信息失败:', e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理权限错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // 处理403权限错误
      if (error.response.status === 403) {
        console.error('权限错误:', error.response.data.error);
        // 可以在这里添加跳转到登录页的逻辑
      }
      // 处理401未授权错误
      if (error.response.status === 401) {
        console.error('未授权访问:', error.response.data.error);
      }
    }
    return Promise.reject(error);
  }
);

// 用户相关API
export const userAPI = {
  // 创建用户
  createUser: (userData) => api.post('/users', userData),
  
  // 获取用户信息
  getUser: (phone) => api.get('/users', { params: { phone } }),
};

// 报告相关API
export const reportAPI = {
  // 创建检测报告
  createReport: (formData) => {
    return api.post('/reports', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // 获取单个报告（带权限验证）
  getReport: (reportId) => api.get(`/reports/${reportId}`),
  
  // 获取用户的所有报告（带权限验证）
  getUserReports: (userId) => api.get('/reports', { params: { user_id: userId } }),
};

export default api;

